// import {
//   Box,
//   Button,
//   useDisclosure,
//   useToast
// } from "@chakra-ui/react";

// import { useEffect, useState } from "react";

// import DataTable from "react-data-table-component";

// import FormModal from "./FormModal";

// import { PageHeader } from "../../components/common/PageHeader";

// import { ZonaService } from "../../services/zona.service";

// export default function ListPage() {

//   const toast = useToast();

//   const { isOpen, onOpen, onClose } = useDisclosure();

//   const [rows, setRows] = useState<any[]>([]);
//   const [editing, setEditing] = useState<any>(null);

//   async function load() {
//     const data = await ZonaService.findAll();
//     setRows(data);
//   }

//   useEffect(() => {
//     load();
//   }, []);

//   async function handleSave(data: any) {
//     try {

//       if (editing) {
//         await ZonaService.update(editing.id, data);
//       } else {
//         await ZonaService.create(data);
//       }

//       toast({
//         title: "Salvo com sucesso",
//         status: "success"
//       });

//       setEditing(null);
//       onClose();
//       load();

//     } catch {
//       toast({
//         title: "Erro ao salvar",
//         status: "error"
//       });
//     }
//   }

//   async function handleDelete(id: number) {
//     await ZonaService.delete(id);
//     load();
//   }

//   const columns = [
//     { name: "Número", selector: (r: any) => r.numero },
//     { name: "Descrição", selector: (r: any) => r.descricao },
//     {
//       name: "Ações",
//       cell: (row: any) => (
//         <Box>
//           <Button size="sm" onClick={() => { setEditing(row); onOpen(); }}>
//             Editar
//           </Button>

//           <Button
//             size="sm"
//             colorScheme="red"
//             ml={2}
//             onClick={() => handleDelete(row.id)}
//           >
//             Excluir
//           </Button>
//         </Box>
//       )
//     }
//   ];

//   return (
//     <Box>
//       <PageHeader
//         title="Zonas"
//         onNew={() => {
//           setEditing(null);
//           onOpen();
//         }}
//       />

//       <DataTable
//         columns={columns}
//         data={rows}
//         pagination
//       />

//       <FormModal
//         isOpen={isOpen}
//         onClose={onClose}
//         onSave={handleSave}
//         initialData={editing}
//       />
//     </Box>
//   );
// }

import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Input,
  Text,
  Tooltip,
  useDisclosure,
  useToast
} from "@chakra-ui/react";

import {
  FiEdit,
  FiSearch,
  FiTrash2,
  FiX
} from "react-icons/fi";

import {
  useEffect,
  useMemo,
  useState
} from "react";

import DataTable from "react-data-table-component";

import FormModal from "./FormModal";

import ContentCard from "../../components/common/ContentCard";

import { PageHeader } from "../../components/common/PageHeader";

import { ZonaService } from "../../services/zona.service";

export default function ListPage() {

  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [rows, setRows] = useState<any[]>([]);
  const [editing, setEditing] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const [numeroFilter, setNumeroFilter] = useState("");
  const [descricaoFilter, setDescricaoFilter] = useState("");

  const [showNumero, setShowNumero] = useState(false);
  const [showDescricao, setShowDescricao] = useState(false);

  async function loadData() {
    try {
      setLoading(true);
      const data = await ZonaService.findAll();
      const normalizedRows = Array.isArray(data)
        ? data
        : Array.isArray((data as any)?.data)
          ? (data as any).data
          : [];

      setRows(normalizedRows);

      // setRows(data);
    } catch {
      toast({ title: "Erro ao carregar zonas", status: "error" });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  async function handleDelete(id: number) {

    if (!confirm("Deseja excluir esta zona?")) return;

    try {
      await ZonaService.delete(id);
      toast({ title: "Zona excluída", status: "success" });
      loadData();
    } catch {
      toast({ title: "Erro ao excluir", status: "error" });
    }
  }

  async function handleSave(data: any) {

    try {

      if (editing) {
        await ZonaService.update(editing.id, data);
      } else {
        await ZonaService.create(data);
      }

      toast({ title: "Salvo com sucesso", status: "success" });

      setEditing(null);
      onClose();
      loadData();

    } catch {
      toast({ title: "Erro ao salvar", status: "error" });
    }
  }

  const filtered = useMemo(() => {

    return rows.filter(item => {
      return (
        String(item.numero)
          .toLowerCase()
          .includes(numeroFilter.toLowerCase()) &&

        item.descricao
          ?.toLowerCase()
          .includes(descricaoFilter.toLowerCase())
      );
    });

  }, [rows, numeroFilter, descricaoFilter]);

  const columns = [

    {
      name: showNumero ? (

        <Input
          size="xs"
          autoFocus
          placeholder="Número..."
          value={numeroFilter}
          onChange={(e) => setNumeroFilter(e.target.value)}
          onBlur={() => {
            if (!numeroFilter) setShowNumero(false);
          }}
        />

      ) : (

        <HStack>
          <Text>Número</Text>
          <IconButton
            aria-label=""
            icon={<FiSearch />}
            size="xs"
            variant="ghost"
            onClick={() => setShowNumero(true)}
          />
        </HStack>
      ),

      selector: (row: any) => row.numero,
      sortable: true,
      width: "160px"
    },

    {
      name: showDescricao ? (

        <Input
          size="xs"
          autoFocus
          placeholder="Descrição..."
          value={descricaoFilter}
          onChange={(e) => setDescricaoFilter(e.target.value)}
          onBlur={() => {
            if (!descricaoFilter) setShowDescricao(false);
          }}
        />

      ) : (

        <HStack>
          <Text>Descrição</Text>
          <IconButton
            aria-label=""
            icon={<FiSearch />}
            size="xs"
            variant="ghost"
            onClick={() => setShowDescricao(true)}
          />
        </HStack>
      ),

      selector: (row: any) => row.descricao,
      sortable: true
    },

    {
      name: "Ações",
      width: "180px",
      cell: (row: any) => (
        <Flex gap={2}>

          <Tooltip label="Editar">
            <IconButton
              aria-label=""
              icon={<FiEdit />}
              colorScheme="blue"
              onClick={() => {
                setEditing(row);
                onOpen();
              }}
            />
          </Tooltip>

          <Tooltip label="Excluir">
            <IconButton
              aria-label=""
              icon={<FiTrash2 />}
              colorScheme="red"
              onClick={() => handleDelete(row.id)}
            />
          </Tooltip>

        </Flex>
      )
    }
  ];

  return (
    <Box>

      <PageHeader
        title="Zonas"
        onNew={() => {
          setEditing(null);
          onOpen();
        }}
      />

      <Flex justify="flex-end" mb={4}>
        <Button
          size="sm"
          variant="outline"
          leftIcon={<FiX />}
          onClick={() => {
            setNumeroFilter("");
            setDescricaoFilter("");
            setShowNumero(false);
            setShowDescricao(false);
          }}
        >
          Limpar filtros
        </Button>
      </Flex>

      <ContentCard>

        <DataTable
          columns={columns}
          data={filtered}
          progressPending={loading}
          pagination
          highlightOnHover
          responsive
          noDataComponent={<Box p={6}>Nenhuma zona encontrada.</Box>}
        />

      </ContentCard>

      <FormModal
        isOpen={isOpen}
        onClose={onClose}
        onSave={handleSave}
        initialData={editing}
      />

    </Box>
  );
}